import { render } from "./TransactionLog.vue?vue&type=template&id=255c5dc5"
import script from "./TransactionLog.vue?vue&type=script&lang=js"
export * from "./TransactionLog.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__